import CopyableText from 'components/atoms/buttons/copyable-text';
import Icon from 'assets/img/icons/box-arrow-up-top.svg?react';
import { Link } from 'react-router-dom';
import { Routes } from 'router/routes';
import { languagesMap } from 'constants/languages';

import s from './styles.module.scss';

import type { Languages } from 'infrastructure/enums';
import type { FC } from 'react';

interface PatientCellProps {
  name: string;
  guid: string;
  language?: Languages;
  dob?: string;
  toggleOpen: () => void;
}

const PatientCell: FC<PatientCellProps> = ({
  name,
  guid,
  toggleOpen,
  language,
  dob = '',
}) => {
  return (
    <div className={s['patient-cell-wrapper']}>
      <Link
        className={s['open-profile-btn']}
        to={Routes.patientGuid(guid)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          toggleOpen();
        }}
      >
        <Icon width={16} height={16} className={s['open-profile-icon']} />
      </Link>
      <div className={s['patient-info-wrapper']}>
        <p className={s.name}>
          {name} <span>{dob}</span>
        </p>
        <CopyableText className={s.guid} value={guid} label={guid} />
        {language && (
          <p className={s['mob-language']}>{languagesMap[language]}</p>
        )}
      </div>
    </div>
  );
};
export default PatientCell;
